import { dateTimeHelper, DateTimePeriod } from "../../helper/date-time-helper";
import { IS3Token, IStorageExternal } from "./storage-external";
import { IShardRepositoryRaw } from "../../api/entities/shard-repository";

const persistentTokenFauxDurationYears = 500;

export class StorageS3 implements IStorageExternal {
    getToken(storageNode: IShardRepositoryRaw): IS3Token {
        let expiration = dateTimeHelper.add(new Date(), persistentTokenFauxDurationYears, DateTimePeriod.Year);
        return {
            accessKeyId: storageNode.key,
            secretAccessKey: storageNode.secret,
            sessionToken: '',
            expiration: expiration,
            endPoint: storageNode.endpointURL
        };
    }
}
